<template>
    <div>
        <div class="composer" style="max-height: 100%; height: 100%; overflow: hidden">
            <div class="composer__header">
                <div class="flex-grow">
                    <a href="javascript:void(0)" @click="toolbarOpen = ! toolbarOpen">
                        <app-icon icon="bars" />
                    </a>

                    <a href="javascript:void(0)" v-if="Object.keys(templates).length > 0" @click="templatesModalOpen = true; templatesModalLoading = false;">
                        <app-icon icon="columns" />
                    </a>

                    <a href="javascript:void(0)" @click="custom.open = true">
                        <app-icon icon="cog" />
                    </a>
                </div>
                <div><i class="fal fa-atom text-4xl text-blue"></i></div>
                <div class="ml-auto flex-grow text-right">
                    <button class="text-white bg-blue px-8 py-2 rounded-full hover:bg-blue-dark" @click="save">Save</button>
                </div>
            </div>
            <div class="composer__body" style="height: 100%; overflow: hidden;">
                <div class="composer__col w-1/6" v-show="toolbarOpen">
                    <app-elements
                        :items="elements"
                        @selected="addElement"
                        @addSection="addSection"
                    />
                </div>
                <div class="composer__playground composer__col" style="flex-basis: 0;">
                    <app-playground
                        :sections="sections"
                        @addSection="addSection"
                        @addRow="addRow"
                        @addColumn="addColumn"
                        @deleteSection="deleteSection"
                        @deleteRow="deleteRow"
                        @deleteColumn="deleteColumn"
                        @deleteElement="deleteElement"
                        @selected="setActiveElement"
                        @repositionFixedItems="repositionFixedItems"
                    />
                </div>
                <div class="composer__col w-1/4" v-if="settingsOpen" style="padding-bottom: 65px;">
                    <app-settings
                        :element="activeElement"
                        @close="activeElement = {type: 'section',object: null}; settingsOpen = false"
                        :languages="languages"
                        :locale="locale"
                    />
                </div>
            </div>
        </div>

        <app-modal v-if="custom.open" tabindex="-1" role="dialog" @modal-close="custom.open = false">
            <div
                class="modal__box  modal__box--xlarge"
            >
                <div>
                    <app-heading
                        class="modal__ttl"
                        element="h2"
                        v-html="`Settings`"
                    />
                    <div class="p-12">
                        <app-field-code
                            label="Custom CSS"
                            name="css"
                            placeholder="Custom CSS"
                            v-model="custom.css"
                            mode="text/css"
                        />

                        <app-field-code
                            label="Custom JS"
                            name="js"
                            placeholder="Custom JS"
                            v-model="custom.js"
                            mode="text/javascript"
                        />
                    </div>
                </div>
                <div class="modal__footer">
                    <div class="flex items-center ml-auto">
                        <app-button class="btn btn--primary btn--primary--sml" element="button" @click="custom.open = false">Save</app-button>
                    </div>
                </div>
            </div>
        </app-modal>

        <app-modal v-if="templatesModalOpen" tabindex="-1" role="dialog" @modal-close="templatesModalOpen = false">
            <div
                class="modal__box  modal__box--xlarge"
            >
                <div>
                    <app-heading
                        class="modal__ttl"
                        element="h2"
                        v-html="`Templates`"
                    />
                    <div class="p-12">
                        <div v-if="templatesModalLoading">
                            <loader />
                        </div>
                        <div v-else>
                            <p class="text-xs block mb-4 text-grey-darker">Selecting a theme will remove your current page contents.</p>
                            <div class="flex flex-wrap -mx-2">
                                <div class="px-2 w-1/4 mb-4" v-for="(name, key) in templates">
                                    <div class="p-6 border border-grey-darker cursor-pointer rounded-lg text-grey-darker text-center hover:bg-blue hover:text-white hover:border-blue" @click="setTemplate(key)">
                                        {{ name }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal__footer" v-if="!templatesModalLoading">
                    <div class="flex items-center ml-auto">
                        <app-button class="btn btn--primary btn--primary--sml" element="button" @click="templatesModalOpen = false">Save</app-button>
                    </div>
                </div>
            </div>
        </app-modal>
    </div>
</template>

<script>
    import Vue from 'vue';

    import Api from '@/api/index.js';

    import Elements from './Elements';
    import Playground from './Playground';
    import Settings from './Settings';
    import Heading from '@/components/Heading';
    import Modal from '@/components/Modal';
    import Button from '@/components/Button';
    import FieldCode from '@/components/fields/inputs/Code';

    import './Elements';

export default {
    props: ['saved', 'locale'],

    components: {
        'app-elements': Elements,
        'app-playground': Playground,
        'app-settings': Settings,
        'app-heading': Heading,
        'app-modal': Modal,
        'app-button': Button,
        'app-field-code': FieldCode
    },
    data: () => ({
        initialLoading: true,
        loading: false,

        settingsOpen: false,
        toolbarOpen: true,

        activeElement: {
            type: 'section',
            object: null
        },

        languages: [
            {
                name: 'English',
                key: 'en',
                default: true
           },
            {
                name: 'German',
                key: 'de',
                default: false
           },
       ],

        templatesModalOpen: false,
        templatesModalLoading: false,
        templates: {},
        elements: [],
        sections: [],
        custom: {
            css: '',
            js: '',
            open: false,
        }
    }),

    /**
     * Mount the component and retrieve its initial data.
     */
    created() {
        this.getElements()
            .then(response => {
                this.loading = false;
                this.initialLoading = false;
            });
    },

    mounted() {
        if (this.saved) {
            if (typeof this.saved.sections !== 'undefined') {
                this.sections = this.saved.sections;
            }
            if (typeof this.saved.css !== 'undefined' && this.saved.css !== null) {
                this.custom.css.value = this.saved.css;
            }
            if (typeof this.saved.js !== 'undefined' && this.saved.js !== null) {
                this.custom.js.value = this.saved.js;
            }
        }

        if (this.sections.length == 0) {
            let sectionIndex = this.createSection(true);
            let rowIndex     = this.createRow(sectionIndex);
            this.createColumn(sectionIndex, rowIndex);
        }
    },

    methods: {
        repositionFixedItems() {
            let hasFixedItems = false;
            for (let i in this.sections) {
                let section = this.sections[i];
                if (typeof section.settings.fixed != 'undefined' && section.settings.fixed.isFixed && typeof section.settings.fixed.position != 'undefined') {
                    hasFixedItems = true;
                }
            }

            if (hasFixedItems) {
                for (let i in this.sections) {
                    let section = this.sections[i];

                    if (typeof section.settings.fixed == 'undefined' || (typeof section.settings.fixed != 'undefined' && !section.settings.fixed.isFixed)) {
                        this.sections.splice(i, 1);
                        this.sections.splice(0, 0, section);

                        break;
                    }
                }

                let items = JSON.parse(JSON.stringify(this.sections));

                for (let i in items) {
                    let section = items[i];

                    if (typeof section.settings.fixed != 'undefined' && section.settings.fixed.isFixed && typeof section.settings.fixed.position != 'undefined') {
                        this.sections.forEach((item, index) => {
                            if (typeof item.settings.fixed != 'undefined' && item.settings.fixed.isFixed && typeof item.settings.fixed.position != 'undefined') {
                                if (item.settings.fixed.position == section.settings.fixed.position && index != item.settings.fixed.position) {
                                    this.sections.splice(index, 1);
                                    this.sections.splice(item.settings.fixed.position, 0, item);
                                }
                            }
                        });
                    }
                }
            }
        },

        getElements() {
            return Api.request('get', `composer/elements`)
                .then( ({data}) => {
                    this.elements = data.elements;
                    this.templates = data.templates;
                } );
        },

        save() {
            for (let i = 0; i < this.sections.length; i++) {
                this.sections[i].open = false;
            }

            this.$emit('save', {
                sections: this.sections,
                css: this.custom.css.value,
                js: this.custom.js.value,
            });
        },

        setActiveElement(element) {
            this.settingsOpen = false;

            this.activeElement = {
                type: 'section',
                object: null
            };

            this.$nextTick(() => {
                this.settingsOpen = true;

                this.activeElement = element;
            })
        },

        deleteSection(sectionIndex) {
            Vue.delete(this.sections, sectionIndex);

            this.settingsOpen = false;
        },

        addSection() {
            this.createSection();
        },

        addRow(sectionIndex) {
            this.createRow(sectionIndex);
        },

        deleteRow(sectionIndex, rowIndex) {
            Vue.delete(this.sections[sectionIndex].rows, rowIndex);

            this.settingsOpen = false;
        },

        addColumn(sectionIndex, rowIndex) {
            this.createColumn(sectionIndex, rowIndex)
        },

        deleteColumn(sectionIndex, rowIndex, colIndex) {
            Vue.delete(this.sections[sectionIndex].rows[rowIndex].columns, colIndex);

            this.settingsOpen = false;
        },

        addElement(element) {
            let sectionIndex = this.createSection();
            let rowIndex     = this.createRow(sectionIndex);
            let columnIndex  = this.createColumn(sectionIndex, rowIndex);

            element.settings = {"boxModel":{"padding":{"top":0,"right":0,"bottom":0,"left":0},"margin":{"top":0,"right":0,"bottom":0,"left":0},"border":{"top":0,"right":0,"bottom":0,"left":0,"type":"none","color":""},"borderRadius":{"topLeft":0,"topRight":0,"bottomLeft":0,"bottomRight":0}},"design":{"shadow":"","text":{"color":"","style":"","capitalisation":"","lineheight":"","spacing":"","weight":"","size":"","family":"","align":""},"background":{"url":"","color":"","media":"","attachment":"","position":"","repeat":"","size":""}},"attributes":{"classes":"","id":""}};

            this.sections[sectionIndex].rows[rowIndex].columns[columnIndex].elements.push(JSON.parse(JSON.stringify(element)));
        },

        deleteElement(sectionIndex, rowIndex, colIndex, elIndex) {
            Vue.delete(this.sections[sectionIndex].rows[rowIndex].columns[colIndex].elements, elIndex);

            this.settingsOpen = false;
        },

        createSection(isOpen) {
            this.sections.push(
                {"rows":[],"open":typeof isOpen !== 'undefined' ? isOpen : false,"settings":{"name":"","contained":true,"wiggles":{"top":false,"bottom":false},"boxModel":{"padding":{"top":0,"right":0,"bottom":0,"left":0},"margin":{"top":0,"right":0,"bottom":0,"left":0},"border":{"top":0,"right":0,"bottom":0,"left":0,"type":"none","color":""},"borderRadius":{"topLeft":0,"topRight":0,"bottomLeft":0,"bottomRight":0}},"design":{"shadow":"","text":{"color":"","style":"","capitalisation":"","lineheight":"","spacing":"","weight":"","size":"","family":"","align":""},"background":{"url":"","color":"","media":"","attachment":"","position":"","repeat":"","size":""}},"attributes":{"classes":"","id":""}}}
            );

            return this.sections.length - 1;
        },
        createRow(sectionIndex) {
            this.sections[sectionIndex].rows.push({
                "columns":[],"open":true,"settings":{"reverse":{"enable":false,"default":false,"small":false,"medium":false,"large":false,"xlarge":false},"boxModel":{"padding":{"top":0,"right":0,"bottom":0,"left":0},"margin":{"top":0,"right":0,"bottom":0,"left":0},"border":{"top":0,"right":0,"bottom":0,"left":0,"type":"none","color":""},"borderRadius":{"topLeft":0,"topRight":0,"bottomLeft":0,"bottomRight":0}},"design":{"shadow":"","text":{"color":"","style":"","capitalisation":"","lineheight":"","spacing":"","weight":"","size":"","family":"","align":""},"background":{"url":"","color":"","media":"","attachment":"","position":"","repeat":"","size":""}},"attributes":{"classes":"","id":""}}
            });

            return this.sections[sectionIndex].rows.length - 1;
        },
        createColumn(sectionIndex, rowIndex) {
            this.sections[sectionIndex].rows[rowIndex].columns.push({
                "elements":[],"settings":{"responsive":{"default":{"width":"w-full","offset":"false","visible":true},"sm":{"width":"w-full","offset":"false","visible":true},"md":{"width":"w-full","offset":"false","visible":true},"lg":{"width":"w-full","offset":"false","visible":true},"xl":{"width":"w-full","offset":"false","visible":true}},"boxModel":{"padding":{"top":0,"right":0,"bottom":0,"left":0},"margin":{"top":0,"right":0,"bottom":0,"left":0},"border":{"top":0,"right":0,"bottom":0,"left":0,"type":"none","color":""},"borderRadius":{"topLeft":0,"topRight":0,"bottomLeft":0,"bottomRight":0}},"design":{"shadow":"","text":{"color":"","style":"","capitalisation":"","lineheight":"","spacing":"","weight":"","size":"","family":"","align":""},"background":{"url":"","color":"","media":"","attachment":"","position":"","repeat":"","size":""}},"attributes":{"classes":"","id":""},"flexbox":false}
            });

            return this.sections[sectionIndex].rows[rowIndex].columns.length - 1;
        },
        setTemplate(index) {
            return Api.request('get', `composer/template?name=${index}`)
                .then( ({data}) => {
                    if (typeof data.sections !== 'undefined') {
                        this.sections = data.sections;
                    }
                    if (typeof data.css !== 'undefined' && data.css !== null) {
                        this.custom.css.value = data.css;
                    }
                    if (typeof data.js !== 'undefined' && data.js !== null) {
                        this.custom.js.value = data.js;
                    }
                } )
                .then(response => {
                    this.templatesModalOpen = false;
                    this.templatesModalLoading = true;
                });
        }
    },

    computed: {

    }
}
</script>

<style>
    .composer {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;

        background: white;
        z-index: 80;

        overflow: auto;
    }

    .composer__ttl {
        @apply .p-6 .bg-blue .text-white;
    }

    .composer__ttl h1, .composer__ttl h2, .composer__ttl h3, .composer__ttl h4, .composer__ttl h5, .composer__ttl h6 {
        @apply .text-base .text-white;
    }

    .composer__header {
        @apply .fixed .flex .items-center .shadow .w-full .h-16 .z-50 .p-6;

        top: 0;
        left: 0;
    }

    .composer__body {
        @apply .flex .flex-grow .w-full .min-h-full .pt-16;

        background: #f4f4f4;
    }

    .composer__playground {
        @apply .flex-grow .bg-white .min-h-full;
    }

    .composer__col {
        @apply .relative;

        max-height: 100%; overflow-y: scroll; overflow-x: hidden; height: 100%;

        border-right: 1px solid #e0e0e0;
    }

    .composer__header a {
        @apply .text-grey-darkest .text-2xl .mr-6 .no-underline;

        transition: all 0.2s ease-in-out;
    }

    .composer__header a:hover {
        @apply .text-blue;
    }
</style>



// WEBPACK FOOTER //
// src/components/composer/Builder.vue